/* eslint-disable */
import axios from 'axios'

const BASE_URL = 'https://api-apollo.tianenusa.com'
// const BASE_URL = 'http://localhost:8080'

export { checkLogin, getUser, login, logout, register, setUser, verifyToken }

function verifyToken(token) {
  const url = `${BASE_URL}/verify`
  return axios.post(url, {token: token})
    .then(function() {
      return true
    })
    .catch(function() {
      return false
    })
}

function checkLogin() {
  const user = JSON.parse(getUser())
  if (user === undefined || user === null || user.token === undefined || user.token === null) {
    return Promise.resolve(false)
  }
  return verifyToken(user.token)
}

function setUser(user) {
  localStorage.setItem('user', JSON.stringify(user))
}

function getUser() {
  return localStorage.getItem('user')
}

function logout() {
  localStorage.removeItem('user')
}

function register(passcode, username, password, email, fullName) {
  const url = `${BASE_URL}/register`
  return axios.post(url, {
    passcode: passcode,
    username: username,
    password: password,
    email: email,
    fullName: fullName})
}

function login(username, password) {
  const url = `${BASE_URL}/login`
  return axios.post(url, {
    username: username,
    password: password})
      .then(response => response.data)
      .catch(err => err.response.data)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js